import { render, staticRenderFns } from "./AtlassianAccessWrapper.vue?vue&type=template&id=4d5e9086&scoped=true&"
import script from "./AtlassianAccessWrapper.vue?vue&type=script&lang=js&"
export * from "./AtlassianAccessWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AtlassianAccessWrapper.vue?vue&type=style&index=0&id=4d5e9086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5e9086",
  null
  
)

export default component.exports